import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { RequestCacheContext } from "./fetchCacheContext";
var FIVE_MINUTES = 5 * 60 * 1000;

var useFetchData = function useFetchData(fetchData, config) {
  var _config$cacheTime;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      refetchTrigger = _useState6[0],
      setRefetch = _useState6[1];

  var prevRefetchRef = useRef();
  var refetch = useCallback(function () {
    setRefetch(function (prev) {
      return prev + 1;
    });
  }, []);
  var key = config === null || config === void 0 ? void 0 : config.key;
  var isUseCache = (config === null || config === void 0 ? void 0 : config.useAutoCache) === true && typeof key === 'string';
  var cacheTime = (_config$cacheTime = config === null || config === void 0 ? void 0 : config.cacheTime) !== null && _config$cacheTime !== void 0 ? _config$cacheTime : FIVE_MINUTES;

  var _ref = useContext(RequestCacheContext),
      getRequestCache = _ref.getRequestCache,
      initRequest = _ref.initRequest,
      updateRequest = _ref.updateRequest;

  useEffect(function () {
    handleFetch();

    function handleFetch() {
      //Only run the fetch data logic in the first render, or the refetch function has been called.
      if (prevRefetchRef.current === refetchTrigger) {
        return;
      }

      var isFirstFetch = refetchTrigger === 0;

      if (config !== null && config !== void 0 && config.externalCache && isFirstFetch) {
        setData(config.externalCache);
        setLoading(false);
        return;
      } // In the user request modal, we may fetch multiple solution list at the same time. For getting the latest cache status, use the setTimeout here to delay the read of the cache.


      setTimeout(function () {
        requestData();
      }, 0);
    }

    function requestData() {
      return _requestData.apply(this, arguments);
    }

    function _requestData() {
      _requestData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var cache, isFetching, isFetchedAndValid, _yield$fetchData, _data;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                cache = getRequestCache(key, cacheTime);
                isFetching = (cache === null || cache === void 0 ? void 0 : cache.status) === 'loading';
                isFetchedAndValid = (cache === null || cache === void 0 ? void 0 : cache.status) === 'success' && (cache === null || cache === void 0 ? void 0 : cache.isOutOfDate) === false;

                if (!(isUseCache && isFetching)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                if (!(isUseCache && isFetchedAndValid)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return");

              case 7:
                _context.prev = 7;
                isUseCache && cache === null && initRequest(key);
                isUseCache && cache !== null && updateRequest({
                  key: key,
                  data: {
                    status: 'loading'
                  }
                });
                setLoading(true);
                _context.next = 13;
                return fetchData();

              case 13:
                _yield$fetchData = _context.sent;
                _data = _yield$fetchData.data;
                isUseCache && updateRequest({
                  key: key,
                  data: {
                    status: 'success',
                    data: _data
                  }
                });
                setData(_data);
                setLoading(false);
                _context.next = 25;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context["catch"](7);
                isUseCache && updateRequest({
                  key: key,
                  data: {
                    status: 'error'
                  }
                });
                setData(null);
                setLoading(false);

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[7, 20]]);
      }));
      return _requestData.apply(this, arguments);
    }

    return function () {
      prevRefetchRef.current = refetchTrigger;
    };
  }, [cacheTime, config === null || config === void 0 ? void 0 : config.externalCache, fetchData, getRequestCache, initRequest, isUseCache, key, refetchTrigger, updateRequest]);

  if (isUseCache) {
    var _cache$data;

    var cache = getRequestCache(key, cacheTime);
    return {
      data: (_cache$data = cache === null || cache === void 0 ? void 0 : cache.data) !== null && _cache$data !== void 0 ? _cache$data : null,
      isLoading: (cache === null || cache === void 0 ? void 0 : cache.status) === 'loading',
      refetch: refetch
    };
  }

  return {
    data: data,
    isLoading: isLoading,
    refetch: refetch
  };
};

export default useFetchData;